import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Lottie from 'lottie-react';
import successAnimation from '../animations/success-animation.json';

const WelcomeScreen = ({ onComplete }) => {
  const [showAnimation, setShowAnimation] = useState(true);

  useEffect(() => {
    // アニメーション終了まで待って非表示にする
    const timer = setTimeout(() => {
      setShowAnimation(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  const handleClick = async () => {
    if (onComplete) {
      await onComplete();
    }
  };

  return (
    <div style={styles.container}>
      {showAnimation && (
        <div style={styles.animationOverlay}>
          <Lottie 
            animationData={successAnimation} 
            loop={false} 
            style={styles.lottie} 
          />
        </div>
      )}
      <h2 style={styles.message}>
        あなたのお店の<br />
        ポイントカードアプリが<br />
        完成しました！
      </h2>
      <Button
        variant="contained"
        color="primary"
        onClick={handleClick}
      >
        さっそく使ってみる
      </Button>
    </div>
  );
};

const styles = {
  container: {
    position: 'relative',
    textAlign: 'center',
    padding: '3rem',
    backgroundColor: '#fff',
    overflow: 'hidden',
  },
  animationOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 1,
    pointerEvents: 'none',
  },
  lottie: {
    width: '100%',
    height: '100%',
  },
  message: {
    position: 'relative',
    zIndex: 2,
    fontSize: '1.4rem',
    fontWeight: 'bold',
    color: '#333',
    marginTop: '2rem',
    lineHeight: '1.6',
  },
  subText: {
    position: 'relative',
    zIndex: 2,
    fontSize: '1rem',
    color: '#555',
    marginTop: '1rem',
    marginBottom: '1.5rem',
  },
  button: {
    position: 'relative',
    zIndex: 2,
    display: 'inline-block',
    padding: '0.75rem 1.5rem',
    backgroundColor: '#4CAF50',
    color: '#fff',
    textDecoration: 'none',
    borderRadius: '8px',
    fontWeight: 'bold',
    transition: 'background-color 0.3s',
  },
};

export default WelcomeScreen;
